import styled from 'styled-components';

export const NutritiveSolutions = styled.div`
  background: white;
  min-height: 100%;
`
